import { defaultLanguage, isLanguage, type Language } from './translations';

const normalizePath = (path: string) => {
  if (!path.startsWith('/')) {
    return `/${path}`;
  }

  return path;
};

export const stripLanguageFromPathname = (pathname: string) =>
  normalizePath(pathname);

export const createLocalizedPath = (path: string, _language: Language) =>
  normalizePath(path);

const readStoredLanguage = () => {
  try {
    const storedLanguage = window.localStorage.getItem(
      'datasliv-language-preference'
    );

    if (!storedLanguage) {
      return null;
    }

    const parsedLanguage = JSON.parse(storedLanguage);

    return isLanguage(parsedLanguage) ? parsedLanguage : null;
  } catch {
    return null;
  }
};

export const detectBrowserLanguage = (): Language => {
  if (typeof navigator === 'undefined') {
    return defaultLanguage;
  }

  const browserLanguages = [
    navigator.language,
    ...(navigator.languages ?? [])
  ].filter(Boolean);

  const browserMatch = browserLanguages
    .map(browserLanguage => browserLanguage.toLowerCase().split('-')[0])
    .find(isLanguage);

  return browserMatch ?? defaultLanguage;
};

export const getInitialLanguage = (): Language => {
  if (typeof window === 'undefined') {
    return defaultLanguage;
  }

  return readStoredLanguage() ?? detectBrowserLanguage();
};
